<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="고객지원" :IsUseEditorBox="true" device="web">
        <template v-slot:EditorBox>
          <v-row no-gutters>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="조회시작일"
                :menu="true"
                :dateOnly="true"
                :allowMaxDate="searchMaxDate"
                @getDate="setSearchDate($event, 'start')"
              ></i-date-time-picker>
            </v-col>
            <span class="pt-1 mx-1">~</span>
            <v-col>
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="조회종료일"
                :menu="true"
                :dateOnly="true"
                :allowMinDate="searchMinDate"
                @getDate="setSearchDate($event, 'end')"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <DxDataGrid
            id="dxDataGrid"
            class="layout-col-height00"
            width="100%"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-resizing="true"
            :allow-column-reordering="true"
            :row-alternation-enabled="true"
            :column-auto-width="false"
            :column-auto-height="true"
            :show-borders="true"
            :show-row-lines="true"
            :column-hiding-enabled="false"
            :focused-row-enabled="true"
            key-expr="id"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
            <DxSelection select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

            <DxColumn data-field="clntId" data-type="string" :visible="false"></DxColumn>
            <DxColumn
              width="120px"
              data-field="clntNm"
              caption="고객사"
              data-type="string"
              :visible="true"
            ></DxColumn>

            <DxColumn data-field="compId" data-type="string" :visible="false"></DxColumn>

            <!-- <DxColumn data-field="writeDt" data-type="string" :visible="false"></DxColumn> -->
            <DxColumn
              data-field="save"
              data-type="string"
              width="120px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn
                  color="primary"
                  elevation="0"
                  dark
                  small
                  @click="btnDetail(cellInfo)"
                  class="grid-btn rounded"
                >상세보기</v-btn>
              </div>
            </template>
            <DxColumn
              data-field="subject"
              caption="제목"
              width="300px"
              data-type="string"
              alignment="left"
              :allow-editing="false"
              css-class="devest-grid-header-require"
            ></DxColumn>

            <DxColumn
              data-field="content"
              caption="문제내용"
              data-type="string"
              alignment="left"
              :allow-editing="false"
            ></DxColumn>
            <DxColumn
              data-field="reporterNm"
              caption="보고자"
              width="80px"
              data-type="string"
              alignment="center"
              :allow-editing="false"
            ></DxColumn>
            <DxColumn
              data-field="createdAt"
              caption="보고일자"
              width="120px"
              data-type="string"
              alignment="center"
              :allow-editing="false"
            ></DxColumn>

            <DxColumn
              data-field="requestedDate"
              caption="수정요청일"
              width="100px"
              data-type="string"
              alignment="center"
              edit-cell-template="dateEditor"
              :visible="false"
            ></DxColumn>
            <template #dateEditor="{ data: cellInfo}">
              <div>
                <DxDateBox
                  :value="cellInfo.value"
                  type="date"
                  picker-type="calendar"
                  display-format="yyyy.MM.dd"
                  :use-mask-behavior="true"
                  @value-changed="onDateValueChanged($event, cellInfo)"
                />
              </div>
            </template>
            <DxColumn
              data-field="solvedBy"
              caption="처리담당자"
              width="90px"
              data-type="string"
              alignment="center"
              :allow-editing="true"
              :visible="false"
            >
              <!-- <DxLookup :data-source="dsSupportMan" value-expr="userCd" display-expr="userNm" /> -->
            </DxColumn>
            <DxColumn
              data-field="statusNm"
              caption="처리상태"
              width="80px"
              data-type="string"
              alignment="center"
              :allow-editing="false"
            ></DxColumn>
            <DxColumn
              data-field="solvedAt"
              caption="처리일자"
              width="120px"
              data-type="string"
              alignment="center"
              :allow-editing="false"
            ></DxColumn>
            <DxColumn
              data-field="confirmBy"
              caption="확인자"
              width="90px"
              data-type="string"
              alignment="center"
              :allow-editing="true"
              :visible="false"
            ></DxColumn>

            <DxColumn
              data-field="contentReq"
              caption="수정/추가 요청사항"
              :width="400"
              data-type="string"
              alignment="left"
              :visible="false"
            ></DxColumn>

            <DxColumn
              data-field="replyContent"
              caption="답변"
              :width="400"
              data-type="string"
              alignment="left"
              :visible="false"
            ></DxColumn>

            <DxColumn
              data-field="fileNm"
              caption="파일명"
              data-type="string"
              alignment="left"
              :visible="false"
            />

            <DxColumn
              data-field="file"
              caption="파일"
              data-type="string"
              alignment="left"
              :visible="false"
            />

            <DxColumn
              data-field="fileId"
              caption="파일아이디"
              data-type="number"
              alignment="left"
              :visible="false"
            />

            <DxColumn
              data-field="__fileUpdate__"
              caption="파일수정여부"
              data-type="boolean"
              alignment="left"
              :visible="false"
            />
          </DxDataGrid>
          <!-- 파일업로드 컴포넌트 -->
          <DxFileUploader
            :ref="dxFileUploaderRef"
            :multiple="false"
            upload-mode="useButton"
            :visible="false"
            @value-changed="onFileValueChanged"
          />
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          :useBtnList="buttonUseList1"
          @btnSearch="btnSearch()"
          @btnAdd="btnAdd()"
          @btnDelete="btnDelete()"
        ></i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getCurrentDate, getPreMonth } from '@/utils/common.js'
import { DxColumn, DxDataGrid, DxEditing, DxSelection } from 'devextreme-vue/data-grid'

import { AesDecrypt } from '@/utils/aes256' //cyrptojs 적용(aes256)
import { getExtension } from '@/utils/common.js'
import { getUserCd } from '@/utils/token'
import { DxFileUploader } from 'devextreme-vue/file-uploader'

import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import DxDateBox from 'devextreme-vue/date-box'
import { DxLookup as DevLookup, DxDropDownOptions } from 'devextreme-vue/lookup'
import { deleteFiles, getFile } from '@/api/baseManage/fileUpload'
import { deleteBugReport, getBugReport, saveBugReport } from '@/api/customerSupport/customerSupport'
import { getCommonCode } from '@/api/common/commonApi'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxEditing,
    'i-card-vertical': iCardVertical,
    'i-date-time-picker': IDateTimePicker,
    DxFileUploader,
    DxDateBox
  },
  data() {
    return {
      allMode: 'allPages',
      txtSubjectName: '',
      dxDataGridRef: 'dxDataGrid',
      gridMain: [],
      buttonUseList1: [
        'btnSearch', //조회
        'btnAdd', // 추가
        'btnDelete' // 삭제
      ],
      // buttonUseList2: ['btnAdd'],
      dxFileUploaderRef: 'uploaderContainer',
      fileData: {},
      files: [],
      bugReportStatusList: [],
      currentCellInfo: null,
      dsSupportMan: [],
      dsSupportBusiness: [],
      bugReportStatus: '',
      // bolCustomerSupply: false,
      bolCustomerSupply: true,
      startDate: getPreMonth(+1),
      endDate: getCurrentDate(0),
      searchMinDate: getPreMonth(+1),
      searchMaxDate: getCurrentDate(0),
      searchStartDate: getPreMonth(+1),
      searchEndDate: getCurrentDate(0).replace(/[^0-9]/g, ''),
      clntId: null,
      compId: null
    }
  },
  beforeMount() {
    this.BaseInitialize()
    this.datagridRefs = [this.dxDataGridRef]
    Promise.all([getCommonCode('CM012') /* 문제보고상태*/]).then(response => {
      // 문제보고상태[조회조건][0]
      this.bugReportStatusList = response[0].list
    })
  },

  mounted() {
    // this.btnSearch()
  },

  computed: {
    getFileData() {
      return this.fileData
    }
  },
  activated() {
    // console.log('this.$route.params.focusedRowKey', this.$route.params.focusedRowKey)
    if (this.$route.params) {
      this.btnSearch().then(res => {
        if (this.$route.params.focusedRowKey) this.DataGrids[0].option('focusedRowKey', this.$route.params.focusedRowKey)
      })
    }
  },
  methods: {
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
      this.btnSearch()
    },
    getAllowEditingOfStatusColumn(cellInfo) {
      console.log('getAllowEditingOfStatusColumn', cellInfo)
      return true
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    async btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true
      })
      const toRouter = {
        name: 'CustomerQADetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    btnSearch() {
      // if (grpAuthCd === 'master') this.clntId = localStorage.getItem('clntId')
      return new Promise((resolve, reject) => {
        this.gridMain = []
        var param = {
          createdStartdate: this.searchStartDate.replace(/[^0-9]/g, ''),
          createdEnddate: this.searchEndDate.replace(/[^0-9]/g, ''),
          clntId: this.getClntId()
        }
        this.openLoading()

        getBugReport(param, true)
          .then(res => {
            if (res.success) {
              this.gridMain = res.list
              res.list.forEach(element => {
                // element.uniqueKey= `${element.docNo}${element.clntId}${element.writeDt}`
                element.statusNm = this.bugReportStatusList.find(el => el.minorCd === element.status).minorNm
                element.createdAt = this.convertDateFormatYYYYMMDD(element.createdAt)
                element.solvedAt = this.convertDateFormatYYYYMMDD(element.solvedAt)
              })
              // this.gridInit(this.DataGrids[0])
              // this.FocusFirstRow(this.DataGrids[0])
              resolve(true)
            }
          })
          .catch(e => {
            reject()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    convertDateFormatYYYYMMDD(fullDatetime) {
      if (fullDatetime && fullDatetime.length > 10) {
        fullDatetime = fullDatetime
          .substring(0, 10)
          .replace('-', '.')
          .replace('-', '.')
      }

      return fullDatetime
    },
    async btnDetail(cellInfo) {
      cellInfo.data.createdStartdate = this.searchStartDate.replace(/[^0-9]/g, '')
      cellInfo.data.createdEnddate = this.searchEndDate.replace(/[^0-9]/g, '')
      const toRouter = {
        name: 'CustomerQADetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    },

    async btnDelete() {
      var selectedRows = await this.DataGrids[0].getSelectedRowsData()
      if (selectedRows.length === 0) {
        // this.$vToastify.warning({ body: this.$t('selectionData') })
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      for (let i = 0; i < selectedRows.length; i++) {
        if (selectedRows[i].createdBy !== getUserCd()) {
          this.vToastify(this.$t('본인의 글만 삭제할 수 있습니다.'), 'info')
          return
        }
      }
      this.vToastifyPrompt(this.$t('doDeleteData'), 'info', current => {
        this.openLoading()
        //this.DataGrids[0].beginUpdate()
        this.DataGrids[0].saveEditData()
        deleteBugReport(selectedRows, true)
          .then(res => {
            selectedRows.forEach(el => {
              let searchParams = {
                targetId: `${el.clntId}_${el.writeDt}_${el.docNo}`,
                targetType: '00004',
                clntId: el.clntId
              }
              getFile(searchParams, false).then(res => {
                deleteFiles(res.list, true)
                  .then(res => {
                    if (res.success) {
                      this.endLoading()
                    }
                  })
                  .finally(() => {
                    this.endLoading()
                  })
                this.endLoading()
              })
            })

            //            this.btnSearch()
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {
            this.deleteCallBack(selectedRows)
            //this.DataGrids[0].endUpdate()
          })
      })
    },

    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    //행 cell에서 데이터 수정후 저장을 누르면 선택된 데이터가 없다는 메세지가 발생
    //위 문제를 해결하기 위해서 아래 소스코드 구현

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.gridMain.findIndex(obj => obj == key)
        this.gridMain.splice(index, 1)
      })
    },
    ///////////////////////////////////////
    /*       File Uploader Event        */
    ///////////////////////////////////////
    async onFileValueChanged(e) {
      console.log('onFileValueChanged', e)
      let file = e.value[0]
      // file 객체를 data에 넣으면 Error로 인하여 file을 string으로 변환 후 넣음
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        let key = this.currentCellInfo.key
        //  console.log(file.name)
        // 확장자랑 파일명 가져오기
        let subFileName = getExtension(file.name)
        let rowIndex = this.currentCellInfo.row.rowIndex
        this.DataGrids[0].cellValue(rowIndex, 'extension', subFileName[1])
        this.DataGrids[0].cellValue(rowIndex, 'fileNm', subFileName[0])
        this.DataGrids[0].cellValue(rowIndex, 'file', reader.result)
        this.DataGrids[0].cellValue(rowIndex, '__fileUpdate__', true)

        console.log(subFileName[0], subFileName[1])

        let a = this.DataGrids[0].option('editing.changes')

        this.DataGrids[0].selectRows(this.currentCellInfo.key, true)
      }
      reader.onerror = error => {
        ////console.log('error', error)
        this.vToastify('파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.', 'error')
        // this.$vToastify.error({ body: '파일업로드에 실패하였습니다. 다시 시도해주시기 바랍니다.' })
      }
    },
    onDateValueChanged(event, cellInfo) {
      //날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`

      //그리드 삽입
      const cell = this.gridMain[cellInfo.rowIndex]
      console.log(cellInfo)
      cell[cellInfo.column.dataField] = dateFormat
      cellInfo.setValue(dateFormat)
      this.$refs[this.dxDataGridRef].instance.selectRows(cellInfo.row.key, true)
    }
  }
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}

//
.header_name {
  margin-left: 2px;
  font-weight: bold;
  font-size: 0.75rem;
  color: #000;
}

.header_value {
  font-weight: bold;
  font-size: 0.75rem;
  color: #2196f3;
}

.fileInfo {
  display: contents;
}

.upload_icon {
  height: 30px !important;
  margin-top: 5px;
  margin-bottom: 5px;
}

.dx-master-detail-row .dx-row-focused .file_icon {
  color: #fff !important;
}
</style>
